import { WebStorageStateStore } from "oidc-client-ts";
import type { AuthProviderProps } from "react-oidc-context";
import { OPENID_SCOPE } from "@farmacenter/api/auth";
import { config } from "../config";

/**
 * Cómo hablar con Keycloak. Aquí no hay pantalla de login ni contraseña: el flujo
 * de código con PKCE lleva a la persona a Keycloak, y vuelve con un token.
 *
 * `oidc-client-ts` descubre el resto de la configuración —endpoints, claves— del
 * documento `.well-known` del emisor, así que no hay URLs escritas a mano que se
 * queden desfasadas.
 */
export const oidcConfig: AuthProviderProps = {
  authority: config.oidc.authority,
  client_id: config.oidc.clientId,
  redirect_uri: config.oidc.redirectUri,
  post_logout_redirect_uri: config.oidc.redirectUri,
  // Solo se pide `openid`. Los ~118 alcances del sistema están configurados como
  // scopes DEFAULT del cliente en Keycloak, así que entran al token sin listarlos en
  // la URL de autorización. Listarlos generaba una cookie KC_RESTART de ~6.8KB que
  // rompía el login: 502 en nginx (cabecera de upstream demasiado grande) y por
  // encima del límite de ~4KB por cookie del navegador. El backoffice sigue siendo
  // "admin con todo" —el token lleva los 118—; la autorización real la aplica el
  // backend (contexto + RBAC).
  scope: OPENID_SCOPE,
  response_type: "code",

  // La sesión sobrevive a recargar la página pero no a cerrar el navegador: es una
  // herramienta de trabajo en un equipo compartido, no una app personal.
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),

  // Refresca el token en silencio antes de que caduque (viven 5 minutos). Sin
  // esto, cada cinco minutos habría un salto a Keycloak a mitad de una tarea.
  automaticSilentRenew: true,

  // Al volver de Keycloak, limpia el `?code=...` de la barra de direcciones para
  // que recargar no reintente un código ya gastado.
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
